import "./calendar.css";
import { setDays, weekdays, months } from "../utils/calendarData";
import { format, getDay, getYear, getMonth, compareAsc } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { setFontSize } from "../utils/fonts";
import leftIcon from "../icons/play-left.png";
import rightIcon from "../icons/play-right.png";
import { useGlobalContext } from "../../../../Context/Context";

const Calendar = () => {
  const { items } = useGlobalContext();

  const [daysInMonth, setDaysInMonth] = useState(setDays(new Date()));

  const calendarRef = useRef();

  const blankSpaces = (isPrev) => {
    const index = isPrev
      ? getDay(daysInMonth[0])
      : 6 - getDay(daysInMonth[daysInMonth.length - 1]);
    if (index === 0) return;
    let array = Array.from({ length: index });
    return array.map((_, index) => {
      return (
        <div className="notebook-calendar-main-item-empty" key={index}></div>
      );
    });
  };

  const handleNextMonth = () => {
    let newDate,
      selectedDay = daysInMonth[0];
    if (getMonth(selectedDay) + 1 === 12)
      newDate = new Date(`${getYear(selectedDay) + 1}-1-1`);
    else {
      newDate = new Date(
        `${getYear(selectedDay)}-${getMonth(selectedDay) + 2}-1`
      );
    }
    setDaysInMonth(setDays(newDate));
  };

  const handlePreviousMonth = () => {
    let newDate,
      selectedDay = daysInMonth[0];
    if (getMonth(selectedDay) - 1 === -1)
      newDate = new Date(`${getYear(selectedDay) - 1}-12-1`);
    else {
      newDate = new Date(
        `${getYear(selectedDay)}-${
          getMonth(selectedDay) - 1 !== 0 ? getMonth(selectedDay) : "1"
        }-1`
      );
    }
    setDaysInMonth(setDays(newDate));
  };

  const checkForToday = (date) => {
    return compareAsc(date, new Date(new Date().setHours(0, 0, 0, 0))) === 0;
  };

  const checkForNotes = (date) => {
    let notebookItemsCurrent = [],
      itemDate;
    items.forEach((item) => {
      itemDate = new Date(item.date);
      if (compareAsc(date, new Date(itemDate.setHours(0, 0, 0, 0))) === 0)
        notebookItemsCurrent.push(item);
    });
    const isBookmarked = notebookItemsCurrent.find((item) => item.isBookmarked);
    console.log(isBookmarked);
    return {
      isBookmarked,
      itemsLength: notebookItemsCurrent.length,
    };
  };

  const resizer = () => {
    if (calendarRef.current !== null) {
      const monthSpan = calendarRef.current.querySelector(
        ".notebook-calendar-month"
      );
      monthSpan.style.fontSize = `${setFontSize(monthSpan, 3)}px`;
      const daySpans = calendarRef.current.querySelectorAll(
        ".notebook-calendar-header-day"
      );
      const dateSpans = calendarRef.current.querySelectorAll(
        ".notebook-calendar-main-item"
      );
      daySpans.forEach(
        (span) => (span.style.fontSize = `${setFontSize(span, 2)}px`)
      );
      dateSpans.forEach(
        (span) => (span.style.fontSize = `${setFontSize(span, 2)}px`)
      );
      const circles = calendarRef.current.querySelectorAll(
        ".notebook-calendar-item-circle"
      );
      circles.forEach(
        (circle) => (circle.style.fontSize = `${setFontSize(circle, 2)}px`)
      );
    }
  };

  window.addEventListener("resize", resizer);

  useEffect(() => {
    resizer();
    return () => window.removeEventListener("resize", resizer);
  }, []);

  return (
    <div className="notebook-calendar" ref={calendarRef}>
      <div className="notebook-calendar-header">
        <img alt="" src={leftIcon} onClick={handlePreviousMonth} />
        <span className="notebook-calendar-month">
          {months[getMonth(daysInMonth[0])].slice(0, 3)}{" "}
          {getYear(daysInMonth[0])}
        </span>
        <img alt="" src={rightIcon} onClick={handleNextMonth} />
      </div>
      <div className="notebook-calendar-main">
        {weekdays.map((day, index) => {
          return (
            <span key={index} className="notebook-calendar-header-day">
              {day}
            </span>
          );
        })}
        {blankSpaces(true)}
        {daysInMonth.map((day, index) => {
          const isToday = checkForToday(day);
          const { isBookmarked, itemsLength } = checkForNotes(day);
          return (
            <div
              className={
                isToday
                  ? "notebook-calendar-main-item today"
                  : "notebook-calendar-main-item"
              }
              key={index}
            >
              <span
                className={
                  itemsLength === 0
                    ? "notebook-calendar-main-item-day red"
                    : "notebook-calendar-main-item-day"
                }
              >
                {format(day, "d").toString().length === 1
                  ? `0${format(day, "d")}`
                  : format(day, "d")}
              </span>
              {itemsLength !== 0 && (
                <div
                  className={
                    isBookmarked
                      ? "notebook-calendar-item-circle bm"
                      : "notebook-calendar-item-circle"
                  }
                >
                  {itemsLength}
                </div>
              )}
            </div>
          );
        })}
        {blankSpaces(false)}
      </div>
    </div>
  );
};

export default Calendar;
